'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _options;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _hashIt = require('hash-it');

var _hashIt2 = _interopRequireDefault(_hashIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultHasher = function defaultHasher(v) {
    return (0, _hashIt2.default)(v);
};

function _options(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var listName = options.listName,
        params = options.params,
        hasher = options.hasher;


    var getSelection = typeof selector === 'function' ? selector : function (cmp) {
        return (0, _get3.default)(cmp, selector);
    };

    var getListName = typeof listName === 'function' ? listName : function () {
        return listName;
    };

    var getParams = typeof params === 'function' ? params : function () {
        return params || {};
    };

    var getHash = typeof hasher === 'function' ? hasher : defaultHasher;

    return {
        getSelection: getSelection,
        getListName: getListName,
        getParams: getParams,
        getHash: getHash
    };
}